import { Box, Typography } from '@mui/material'
import React from 'react'
import { useStyles } from './styles'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { useTranslation } from "react-i18next"
import { QualificationCardProps } from './types'

export const QualificationCard = ({qualification,total, margin}:QualificationCardProps) => {
    const styles = useStyles({margin})
    const { t } = useTranslation()
    
  return (
    <CustomPaper id={'3'} elevation={3} sx={{'&.MuiPaper-root':{margin:'0px'}}}>
      <Box sx={styles.container}>
          <Typography sx={styles.title}>{t('Questionarie.cards.averageMark')}</Typography>
          <Box sx={styles.display}>
              <Typography sx={styles.textBig}>{qualification}</Typography>
              <Typography sx={styles.textSmall}>/</Typography>
              <Typography sx={styles.textSmall} color='c_grey.main'>{total}</Typography>
          </Box>
      </Box>
    </CustomPaper>
  )
}
